import React, { useEffect } from 'react';
import UDHeaderTitle from 'ud-ui/components/header-title';
import { useMainLayout } from 'ud-ui/layout/main/context';
import MigrationPageContent from '../components/migration-page-content';

const MigrationPage: React.FC = () => {
  const { setHeaderContent } = useMainLayout();

  useEffect(() => {
    setHeaderContent(<UDHeaderTitle>Миграция </UDHeaderTitle>);
    return () => setHeaderContent(null);
  }, [setHeaderContent]);

  return <MigrationPageContent />;
};

export default MigrationPage;
